import {
    CheckboxGroupInput,
    RadioButtonGroupInput,
    SelectArrayInput,
    SelectInput,
    type RaRecord,
    type SelectArrayInputProps,
    type SelectInputProps,
} from "react-admin";
import type { ValuesOf } from "../../models/enums";

// @ts-expect-error asd
interface EnumInputProps<
    T extends RaRecord = RaRecord,
    U extends readonly string[] = string[],
> extends SelectInputProps {
    source: keyof T;
    enum: U;
    defaultValue?: ValuesOf<U>;
}
// @ts-expect-error asd
interface EnumArrayInputProps<
    T extends RaRecord = RaRecord,
    U extends readonly string[] = string[],
> extends SelectArrayInputProps {
    source: keyof T;
    enum: U;
    defaultValue?: ValuesOf<U>;
}

export function EnumInput<
    T extends RaRecord = RaRecord,
    U extends readonly string[] = readonly string[],
>(props: EnumInputProps<T, U>): JSX.Element {
    return (
        <SelectInput
            
            sx={{ minWidth: 200, margin: 0 }}
            fullWidth
            {...(props as any)}
            choices={props.enum.map(x => ({ id: x, name: x }))}
        />
    );
}

export function EnumRadioInput<
    T extends RaRecord = RaRecord,
    U extends readonly string[] = readonly string[],
>(props: EnumInputProps<T, U>): JSX.Element {
    return (
        <RadioButtonGroupInput
            sx={{ minWidth: 200, margin: 0 }}
            fullWidth
            {...(props as any)}
            choices={props.enum.map(x => ({ id: x, name: x }))}
        />
    );
}

export function EnumArrayInput<
    T extends RaRecord = RaRecord,
    U extends readonly string[] = readonly string[],
>(props: EnumArrayInputProps<T, U>): JSX.Element {
    return (
        <SelectArrayInput
            sx={{ minWidth: 200 }}
            fullWidth
            {...(props as any)}
            choices={props.enum.map(x => ({ id: x, name: x }))}
        />
    );
}

export function EnumCheckboxInput<
    T extends RaRecord = RaRecord,
    U extends readonly string[] = readonly string[],
>(props: EnumArrayInputProps<T, U>): JSX.Element {
    return (
        <CheckboxGroupInput
            sx={{ [`& .MuiFormControlLabel-root`]: { width: "100%" } }}
            {...(props as any)}
            parse={vals => {
                return vals?.length ? `(${vals.join(",")})` : null;
            }}
            format={s => {
                return s ? s.slice(1, s.length - 1).split(",") : [];
            }}
            choices={props.enum.map(x => ({ id: x, name: x }))}
        />
    );
}
